module.exports = __webpack_public_path__ + "static/media/appManager.027c839c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appManager.png
// module id = 748
// module chunks = 1 3